import { API_URL } from '../../../../../../constants'

export const FETCH_TRANSACTIONS_URL = `${API_URL}/api/external_user/transactions`
